import CitySEOHead from "@/components/feature/CitySEOHead";
import CarrolltonHeroSection from "./components/HeroSection";
import CarrolltonStickyNav from "./components/StickyNav";
import CarrolltonProcessingTimeSection from "./components/ProcessingTimeSection";
import CarrolltonServicesSection from "./components/ServicesSection";
import CarrolltonLocalAreaSection from "./components/LocalAreaSection";
import CarrolltonTestimonialsSection from "./components/TestimonialsSection";
import CarrolltonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CarrolltonComparisonSection from "./components/ComparisonSection";
import CarrolltonMistakesSection from "./components/MistakesSection";
import CarrolltonHowItWorksSection from "./components/HowItWorksSection";
import CarrolltonFAQSection, { faqs } from "./components/FAQSection";
import CarrolltonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CarrolltonFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Carrollton, GA — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Carrollton, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving west Georgia travelers. Get your emergency passport fast!";
const pageKeywords = "expedited passport, emergency passport, Carrollton passport, same day passport Atlanta, fast passport Georgia";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CarrolltonPage() {
  return (
    <>
      <CitySEOHead
        city="Carrollton"
        state="Georgia"
        stateAbbr="GA"
        route="/carrollton"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Carrollton, Georgia"
        geoPosition="33.5804;-85.0761"
        keywords={pageKeywords}
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Carrollton — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Carrollton and west Georgia travelers."
      />

      <div className="font-sans">
      <CarrolltonHeroSection />
      <CarrolltonStickyNav />
      <CarrolltonProcessingTimeSection />
      <CarrolltonServicesSection />
      <CarrolltonLocalAreaSection />
      <CarrolltonTestimonialsSection />
      <CarrolltonAcceptanceFacilitiesSection />
      <CarrolltonComparisonSection />
      <CarrolltonMistakesSection />
      <CarrolltonHowItWorksSection />
      <CarrolltonFAQSection />
      <CarrolltonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/carrollton" state="GA" />
      <CarrolltonFinalCTA />
      </div>
    </>
  );
}